import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import {
	DefaultMentionNameResolver,
	type MentionNameDetails,
	type MentionNameResolver,
	MentionNameStatus,
	type ResolvingMentionProvider,
} from '@atlaskit/mention';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import MentionNameClient from '../../common/utils.tsx';
import { UserTeamProjectMentionProvider } from '../user-team-project-mention-provider/index.tsx';

interface MentionConfig {
	mentionNameResolver: MentionNameResolver;
}

export class UserTeamProjectMentionProviderWithResolverMentionName
	extends UserTeamProjectMentionProvider
	implements ResolvingMentionProvider
{
	config: MentionConfig;

	constructor(
		projectOptions: { projectKey: ProjectKey; projectType?: ProjectType | null },
		teamOptions: { cloudId: string; userId: string | null; orgId?: string },
	) {
		super(projectOptions, teamOptions);
		this.config = {
			mentionNameResolver: new DefaultMentionNameResolver(new MentionNameClient()),
		};
	}

	resolveMentionName(id: string): Promise<MentionNameDetails> | MentionNameDetails {
		if (!this.config.mentionNameResolver) {
			return {
				id,
				name: '',
				status: MentionNameStatus.UNKNOWN,
			};
		}
		return this.config.mentionNameResolver.lookupName(id);
	}

	supportsMentionNameResolving(): boolean {
		return !!this.config.mentionNameResolver;
	}

	cacheMentionName(id: string, mentionName: string): void {
		if (!this.config.mentionNameResolver) {
			return;
		}
		this.config.mentionNameResolver.cacheName(id, mentionName);
	}
}
